import Breadstick from 'breadstick'
const breadstick = new Breadstick()

const Toast = () => import(/* webpackChunkName: "Toast-component" */'@/components/alerts/notification.vue')

/**
 * Shows notification to user.
 * @param {String} message Notification message content
 * @param {{title: String, type: String, position: String, duration: Number }} options
 */
export const notify = (message, options) => {
  if (!message || message === '') {
    console.error('[notification]: The notification expects a message before rendering the toast component.')
    return
  }

  if (!options) {
    return breadstick.notify(({ h, onClose }) => {
      return h(Toast, {
        props: {
          onClose
        }
      }, [message])
    })
  }

  return breadstick.notify(({ h, onClose }) => {
    return h(Toast, {
      props: {
        onClose,
        type: options.type
      }
    }, [
      options.title && h('span', {
        slot: 'title'
      }, options.title),
      message
    ])
  }, {
    ...options.position && { position: options.position },
    ...options.duration && { duration: options.duration }
  })
}

const PhanerooNotifications = {
  install (Vue) {
    // Attach the breadstick API to Vue's prototype
    // to render custom components if need be.
    Vue.prototype.$breadstick = breadstick

    // Attach our notification method to Vue prototype
    Vue.prototype.$notify = notify
  }
}

export default PhanerooNotifications
